<h2 mat-dialog-title [innerHTML]="data.title" class="bg-red text-white"></h2>
<mat-dialog-content [innerHTML]="data.message"></mat-dialog-content>
<mat-dialog-actions align="end">
  <button *ngIf="data.displayCancelButton" mat-button mat-dialog-close>
    {{ data.cancelText }}
  </button>
  <button *ngIf="data.displayConfirmButton" mat-button [mat-dialog-close]="true" color="warn">
    {{ data.confirmText }}
  </button>
</mat-dialog-actions>
